// Added by Inkybay
(function () {
  const inkybayIds = [
    'EFOLI_CUSTOMIZE_IT_BUTTON'
  ];

  function updateProductPage() {
    const inkybayFound = inkybayIds.some(function (id) {
      return document.body.querySelector('[id="' + id + '"]') !== null;
    });

    const quantity = document.querySelector(
      '.product-form__info-item--quantity'
    );

    const payment = document.querySelector(
      '.product-form__payment-container'
    );

    if (quantity) {
      quantity.style.display = inkybayFound ? 'none' : '';
    }

    if (payment) {
      payment.style.display = inkybayFound ? 'none' : '';
    }
  }

  function init() {
    // Normal product: everything stays visible
    updateProductPage();

    // Wait for external Inkybay JS to modify the HTML
    const observer = new MutationObserver(function () {
      updateProductPage();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
// Added by Inkybay